(() => {
  const bindProduct = root => {
    if (root.dataset.buyBound) return;
    root.dataset.buyBound = 'true';
    const button = root.querySelector('[data-add-button]');
    const price = root.querySelector('[data-product-price]');
    const select = root.querySelector('[data-variant-select]');
    const sticky = root.querySelector('[data-sticky-buy]');
    if (!button || !sticky) return;
    const stickyButton = sticky.querySelector('[data-sticky-add]');
    const stickyPrice = sticky.querySelector('[data-sticky-price]');
    const selection = root.querySelector('[data-selection-label]');
    const refresh = () => {
      stickyButton.disabled = button.disabled || Boolean(select?.disabled);
      stickyButton.textContent = button.textContent;
      stickyPrice.textContent = price?.textContent || '';
      const selectedLabel = sticky.querySelector('[data-sticky-selection]');
      if (selectedLabel) selectedLabel.textContent = selection?.textContent || 'Lumidog';
      const option = select?.selectedOptions[0];
      if (selection && option?.value && !select.disabled) {
        selection.textContent = option.dataset.displayTitle || option.textContent;
      }
    };
    const visible = () => {
      sticky.hidden = button.getBoundingClientRect().bottom >= 0;
    };
    root.addEventListener('lumidog:variant-change', refresh);
    select?.addEventListener('change', () => queueMicrotask(refresh));
    const observer = new MutationObserver(refresh);
    observer.observe(button, {childList:true, subtree:true, attributes:true, attributeFilter:['disabled']});
    if (price) observer.observe(price, {childList:true, subtree:true, characterData:true});
    let intersection;
    if ('IntersectionObserver' in window) {
      intersection = new IntersectionObserver(visible);
      intersection.observe(button);
    }
    refresh();
    if (intersection) visible();
    root.addEventListener('shopify:section:unload', () => {
      observer.disconnect();
      intersection?.disconnect();
    }, {once:true});
  };
  const init = (scope = document) => {
    scope.querySelectorAll('[data-product-root]').forEach(bindProduct);
    scope.querySelectorAll('[data-open-details]').forEach(link => {
      if (link.dataset.detailsBound) return;
      link.dataset.detailsBound = 'true';
      link.addEventListener('click', () => {
        const target = document.getElementById(link.hash.slice(1));
        if (target?.matches('details')) target.open = true;
      });
    });
    scope.querySelectorAll('.site-header details').forEach(details => {
      if (details.dataset.menuBound) return;
      details.dataset.menuBound = 'true';
      details.addEventListener('toggle', () => {
        if (details.open) {
          document.querySelectorAll('.site-header details[open]').forEach(other => {
            if (other !== details) other.open = false;
          });
        }
      });
    });
  };
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.site-header details[open]').forEach(details => {
      details.open = false;
      details.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.site-header details[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  const revealHash = () => {
    const target = location.hash === '#SizeGuide' ? document.querySelector('.ld-size-guide') : document.getElementById(location.hash.slice(1));
    if (target?.matches('details')) {
      target.open = true;
      if (location.hash === '#SizeGuide') requestAnimationFrame(() => target.scrollIntoView({block:'start'}));
    }
  };
  window.addEventListener('hashchange', revealHash);
  document.addEventListener('click', event => {
    if (event.target.closest('.native-menu a')) event.target.closest('.native-menu').open = false;
  });
  revealHash();
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
